module.exports = __webpack_public_path__ + "img/publiceBtn.4e557a30.png";